export default __webpack_public_path__ + "static/media/84t.9a8963cc.jpg";